module.exports = __webpack_public_path__ + "img/tubiao-02.076fca95.png";